import moment from "moment";
import * as T from "../../utilities/frontendTypes";
import { SowItem } from "../../utilities/frontendTypes";
import { inputClasses } from "../../Components/Form/InputField";
import Button from "../../Components/Button";
import { useState, useEffect } from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import leaf from '../../../assets/Group.png'
import React from "react";
import { newRetainerInvoice } from "../../services/serviceProvider";


const EditSOW = ({sowDetails, startupName, existingRetainerInvoice} : {sowDetails: T.SowRequestDetails, startupName: string, existingRetainerInvoice: T.Invoice | null}) => {

    const [isRetainerModalOpen, setIsRetainerModalOpen] = useState(false);
    const [isAddingFinalInvoice, setIsAddingFinalInvoice] = useState(false);
    const [finalPreTaxTotal, setFinalPreTaxTotal] = useState(0)
    const [finalTaxRate, setFinalTaxRate] = useState(0)
    const combinedArray = [...sowDetails.sowItemArray, ...sowDetails.paymentArray];
    const [retainerInfoSowItems, setRetainerInfoSowItems] = useState(combinedArray)
    const sortedArray = combinedArray.sort((a, b) => new Date(a.itemDate).getTime() - new Date(b.itemDate).getTime());
    const isTier2 = sowDetails.tier === "2" ? true : false
    const coInvestPercentage = sowDetails.coPayPercentage
    const pageTitleString = (sowStatus: string) => {
      if (sowStatus === "Awaiting Startup Approval") {
        return "Sow Awaiting Startup Approval"
      }
      if (sowStatus === "Awaiting Startup Approval") {
        return "SoW Awaiting Admin Approval"
      }
      if (sowStatus === "Ready to Begin Work") {
        return "Ready to Being Work"
      }
    }

    const handleFilingNumberChange = (event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement> | React.ChangeEvent<HTMLSelectElement>) => {
      const { id, value } = event.target;
      // if (errorArray.includes(id)) {
      //   console.log("yaaaa")
      //   setErrorArray(prev => prev.filter(item => item !== id));
      // }
      let modifyValue = parseFloat(value)

        if (id === "finalPreTaxTotal") {
          setFinalPreTaxTotal(modifyValue)
        } else if (id === "finalTaxRate") {
          setFinalTaxRate(modifyValue)
        } else {
        setRetainerInfoSowItems(prev =>
          prev.map(item =>
            item.itemId === id
              ? { ...item, filingNumber: modifyValue }
              : item
          )
        );
      }
    };

    const handleSowItemStatusChange = (event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement> | React.ChangeEvent<HTMLSelectElement>) => {
      const { id, value } = event.target;
      // if (errorArray.includes(id)) {
      //   console.log("yaaaa")
      //   setErrorArray(prev => prev.filter(item => item !== id));
      // }

      if (value === "Incomplete" || value === "Complete" || value === "Partially Complete")
        setRetainerInfoSowItems(prev =>
          prev.map(item =>
            item.itemId === id
              ? { ...item, finalInvoiceStatus: value }
              : item
          )
        );
    }


    const reqFilingNumberTasks = [
      "Patent Filing, including initial drafting - Canada",
      "Patent Filing, regular application, including initial drafting - US",
      "Patent Filing, including drafting - EP (EU)",
      "Patent Drafting - PCT",
      "Patent Filing - PCT",
      "Patent Filing, provisional application - US",
      "Converting PCT to CA national filing",
      "Convert PCT to US national filing",
      "Converting US provisional to regular US application",
      "Converting US provisional to PCT",
      "Converting US provisional to other national filing",
      "Trademark Filing - Canada",
      "Trademark Filing - US",
      "Trademark Filing - Other jurisdiction",
      "Design Patent/Industrial Design Application - US",
      "Design Patent/Industrial Design Application - Other jurisdiction"
    ];
    
    const getRetainerTotal = () => {
      let totalForRetainer = 0
      sortedArray.map((item, index) => {
      if (item.hasOwnProperty('paymentAmount')) {
        const {paymentAmount} = item as T.Payment
        if (paymentAmount) {
          totalForRetainer = totalForRetainer + paymentAmount
        }
      }
    })
    return totalForRetainer
  }
    
    async function createNewRetainerInvoice () {
      const response = await newRetainerInvoice(sowDetails.sowId, getRetainerTotal());
      if (response.success) {
        console.log("mission complete")
      }
    }

    const printRef = React.useRef(null)

    const handleInvoiceDownload = async () => {
      const element = printRef.current
      if (!element) {
        return;
      }
      const canvas = await html2canvas(element)
      const data = canvas.toDataURL('image/png')
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4"
      });
  
      const imgProperties = pdf.getImageProperties(data)
      const pdfWidth = pdf.internal.pageSize.getWidth()
      const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width
  
      pdf.addImage(data, "PNG", 0, 0, pdfWidth, pdfHeight)
      pdf.save(`${startupName} Retainer SoW`)
    }

    const sowHtml = ( sortedArray.map((item, index) => {
    if (item.hasOwnProperty('category')) {
      const {category, task, taskDescription, deliverable, itemDate, costBreakdown, costBreakdownTotalTax, costBreakdownTotal, itemId, filingNumber, finalInvoiceStatus} = item as SowItem;
      return (
        <div key={itemId} className="w-full flex gap-2 relative mb-4 mt-4  border-cSage border-b-[1px]">
          <div className="h-full flex flex-col justify-between" style={{ width: '15%', display: 'inline-flex' }}>
            <div className="mb-4">
              <p className="flex grow break-word font-normal text-text/80 self-center capitalize">{category}</p>
              <p className="flex grow break-word font-normal text-text/80 self-center capitalize mt-2">{task}</p>
              {
                isAddingFinalInvoice && 
                <div className="relative flex items-center">
                <select id={itemId} name="Task Status" 
                className="w-full bodyLarger select !border-cSecondaryGreen border input" 
                value={finalInvoiceStatus} onChange={handleSowItemStatusChange}>
                  <option disabled value={""}>Please make a selection</option>
                  <option value={"Incomplete"}>Incomplete</option>
                  <option value={"Complete"}>Complete</option>
                  <option value={"Partially Complete"}>Partially Complete</option>
                </select>
              </div>
              }
            </div>
          </div>
          <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
            <p className="">{taskDescription}</p>
          </div>
          <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
            <p className="">{deliverable}</p>
          </div>
          
          {/* <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
            <p className="">{effort}</p>
          </div> */}
          {isAddingFinalInvoice &&
          <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
            {reqFilingNumberTasks.includes(task) &&
              <div className="relative flex items-center">
                <input type="text" id={itemId} name="patentsGranted"
                  className="w-full bodyLarger input !border-cSecondaryGreen border" 
                  inputMode="numeric"
                  pattern="[0-9]*"
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      'Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'
                    ];
                    const isNumberKey = /^\d$/.test(e.key);
                      if (!isNumberKey && !allowedKeys.includes(e.key)) {
                        e.preventDefault(); // Prevent non-numeric keypresses
                      }
                    }}                  
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || /^\d*$/.test(value)) {
                        handleFilingNumberChange(e)
                      }
                    }}
                  value={filingNumber} ></input>
            </div>
          }
          </div>
          }
          {!isAddingFinalInvoice &&
          <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
            <p className="">{moment(itemDate).format('MMM Do YYYY').toString()}</p>
          </div>
          }
          <div className="h-full mb-4" style={{ width: '24%', display: 'inline-block' }}>
            <ul className="w-full">
              {costBreakdown.map((expense, index) => (
                <li key={index} className={index === 0 ? `expenseLi w-full !p-0 border-1 border-b mb-2 border-cSage` : "expenseLi border-1 border-b !p-0 mb-2 border-cSage"}>
                  <div>
                    {expense.itemDescription}
                  </div> 
                  {
                    !expense.isLumpsum &&
                    <div className="flex w-full bodySmaller">
                      <span className="w-1/3">Hours: {expense.effort}</span>
                      <span className="w-2/3">Hourly Rate: ${expense.hourlyRate}</span>
                    </div>                           
                  }
                  <div className="flex w-full bodySmaller pb-2">
                    <span className="w-1/3">$ {expense.amount}</span>
                    <span className="w-2/3">{expense.tax === "0" ? "No Tax" : expense.tax === "0.05" ? `5% tax =  $ ${((parseFloat(expense.amount) * (parseFloat(expense.tax))) + parseFloat(expense.amount)).toFixed(2)}` : `13% tax =  $ ${((parseFloat(expense.amount) * (parseFloat(expense.tax))) + parseFloat(expense.amount)).toFixed(2)}`}  </span>
                  </div>
                </li>
              ))}
            </ul>
            <div className="flex flex-col gap-1">
              <p className="">Pre-Tax: ${costBreakdownTotal.toFixed(2)}</p>
              <p className="">Tax: ${costBreakdownTotalTax.toFixed(2)}</p>
              <p className=""><span className="font-semibold">Total: </span>${(costBreakdownTotal + costBreakdownTotalTax).toFixed(2)}</p>
            </div>
          </div>
        </div>
      );
    } else if (item.hasOwnProperty('paymentType')) {
        const {paymentType, itemDate, coInvestDate, paymentAmount, itemId, preTax, tax} = item as T.Payment
        if (paymentType === "milestone") {
          return (
            <div key={itemId} className="w-full pb-4 mb-4 gap-2 flex border-cSage border-b-[1px]">
              <div className="h-full flex-col" style={{ width: '64%', display: 'inline-flex' }}>
                <p className="font-semibold mb-2">Progress Milestone Payment</p>
              </div>
              <div className="h-full items-center" style={{ width: '12%', display: 'inline-flex' }}>
                <p className="">{moment(itemDate).format('MMM Do YYYY').toString()}</p>
              </div>
              <div className="h-full flex-col justify-center" style={{ width: '24%', display: 'inline-flex' }}>
                <p className=""><span className="">{`Pre-Tax: `}</span> $ {preTax?.toFixed(2)}</p>
                <p className=""><span className="">{`Tax: `}</span> $ {tax?.toFixed(2)}</p>
                <p className=""><span className="font-semibold">{`Total: `}</span> ${paymentAmount?.toFixed(2)}</p>
              </div>
            </div>
          );
        } else if (paymentType === "final" && isTier2) {
          return (
            <div key={itemId} className="w-full gap-2 flex pb-4 mb-4 border-cSage border-b-[1px]">
              <div className="h-full items-center flex-col" style={{ width: '64%', display: 'inline-flex' }}>
                <p className="font-semibold mb-2">Final Payment</p>
              </div>
              <div className="h-full items-center" style={{ width: '12%', display: 'inline-flex' }}>
                <p className="">{moment(itemDate).format('MMM Do YYYY').toString()}</p>
              </div>
              <div className="h-full flex-col justify-center" style={{ width: '14%', display: 'inline-flex' }}>
                <p className=""><span className="">{`Pre Tax: `}</span> $ {preTax?.toFixed(2)}</p>
                <p className=""><span className="">{`Tax: `}</span> $ {tax?.toFixed(2)}</p>
                <p className=""><span className="font-semibold">{`Total: `}</span> ${paymentAmount?.toFixed(2)}</p>
              </div>
          </div>
          )
        } else if (paymentType === "final" && !isTier2 && coInvestDate) {
          return (
            <div className="w-full mb-4 gap-2 flex flex-col border-cSage border-b-[1px]">
              {!isAddingFinalInvoice &&
              <div key={itemId} className="w-full gap-2 flex">
                <div className="h-full items-center" style={{ width: '64%', display: 'inline-flex' }}>
                  <p className="font-semibold mb-2">Final Payment</p>
                </div>
                <div className="h-full items-center" style={{ width: '12%', display: 'inline-flex' }}>
                  <p className="">{moment(itemDate).format('MMM Do YYYY').toString()}</p>
                </div>
                <div className="h-full flex-col gap-2 justify-center border-cSage border-b-[1px]" style={{ width: '24%', display: 'inline-flex' }}>
                  <p className=""><span className="">{`Pre Tax: `}</span> $ {preTax?.toFixed(2)}</p>
                  <p className=""><span className="">{`Tax: `}</span> $ {tax?.toFixed(2)}</p>
                  <p className="pb-2"><span className="font-semibold">{`Total: `}</span> ${paymentAmount?.toFixed(2)}</p>
                </div>
              </div>
              }
              {isAddingFinalInvoice &&
              <div key={itemId} className="w-full gap-2 flex">
                <div className="h-full items-center" style={{ width: '64%', display: 'inline-flex' }}>
                  <p className="font-semibold mb-2">Final Payment</p>
                </div>
                <div className="h-full items-center" style={{ width: '18%', display: 'inline-flex' }}>
                  <div className="relative flex items-center">
                    <p className=""><span className="">{`Pre-Tax: `}</span> $ {preTax?.toFixed(2)}</p>
                    <p className=""><span className="">{`Tax: `}</span> $ {tax?.toFixed(2)}</p>
                    <p className=""><span className="font-semibold">{`SoW Total: `}</span> ${paymentAmount?.toFixed(2)}</p>
                  </div>
                </div>
                <div className="h-full items-center" style={{ width: '18%', display: 'inline-flex' }}>
                  <div className="relative flex items-center">
                    <input type="text" id="finalPreTaxTotal" name="finalPreTaxTotal"
                      className="w-full bodyLarger input !border-cSecondaryGreen border" 
                      inputMode="numeric"
                      pattern="[0-9]*"
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          'Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'
                        ];
                        const isNumberKey = /^\d$/.test(e.key);
                          if (!isNumberKey && !allowedKeys.includes(e.key)) {
                            e.preventDefault(); // Prevent non-numeric keypresses
                          }
                        }}                  
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === "" || /^\d*$/.test(value)) {
                            handleFilingNumberChange(e)
                          }
                        }}
                      value={finalPreTaxTotal}>  
                    </input>
                  </div>
                  <div className="relative flex items-center">
                    <select id="finalTaxRate" name="finalTaxRate" 
                    className="w-full bodyLarger select !border-cSecondaryGreen border input" 
                    value={finalTaxRate} onChange={handleFilingNumberChange}>
                      <option disabled value={""}>Please make a selection</option>
                      <option value={"0"}>No Tax</option>
                      <option value={"0.05"}>5%</option>
                      <option value={"0.13"}>13%</option>
                    </select>
                  </div>
                  <p className=""><span className="font-semibold">{`Invoice Total: `}</span> $ {finalPreTaxTotal * finalTaxRate + finalPreTaxTotal}</p>
                </div>
              </div>
              }
              {!isAddingFinalInvoice &&
              <div className="w-full flex gap-2 py-2">
                <div className="h-full items-center" style={{ width: '64%', display: 'inline-flex' }}>
                  <p className="font-semibold">Co-Invest Payment ({coInvestPercentage}%)</p>
                </div>
                <div className="h-full items-center" style={{ width: '12%', display: 'inline-flex' }}>
                  <p className="">{moment(coInvestDate).format('MMM Do YYYY').toString()}</p>
                </div>
                <div className="h-full flex-col justify-center" style={{ width: '24%', display: 'inline-flex' }}>
                  <p className=""><span className="font-semibold">{`Total: `}</span> ${preTax ? (coInvestPercentage / 100 * preTax).toFixed(2) : ""}</p>
                </div>
              </div>
              }
              {isAddingFinalInvoice &&
              <div className="w-full flex gap-2 py-2">
                <div className="h-full items-center" style={{ width: '64%', display: 'inline-flex' }}>
                  <p className="font-semibold">Co-Invest Payment ({coInvestPercentage}%)</p>
                </div>
                <div className="h-full flex-col justify-center" style={{ width: '18%', display: 'inline-flex' }}>
                  <p className=""><span className="font-semibold">{`SoW Total: `}</span> ${preTax ? (coInvestPercentage / 100 * preTax).toFixed(2) : ""}</p>
                </div>
                <div className="h-full flex-col justify-center" style={{ width: '18%', display: 'inline-flex' }}>
                  <p className=""><span className="font-semibold">{`Invoice Total: `}</span> ${finalPreTaxTotal ? (coInvestPercentage / 100 * finalPreTaxTotal).toFixed(2) : ""}</p>
                </div>
              </div>
              }
            </div>
          )
          }
        } else {
          return <></>
        }
      }))
    
    useEffect(() => {
    }, [isAddingFinalInvoice, finalPreTaxTotal, finalTaxRate])


  return (
    <div>
      {isRetainerModalOpen &&
        <div className="flex flex-col w-full largeModal">
          <div className="flex flex-col w-full mediumModalInner !min-w-[90vw]">
            <div className='flex justify-end w-full'>
              <button onClick={() => setIsRetainerModalOpen(false)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M9 1L1 9M1 1L9 9" stroke="#1A2E25" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
            </div>
            <div className="w-full flex flex-col gap-4" id="retainerInvoice" ref={printRef}>
              <h3>Retainer Invoice</h3>
              <div className="flex justify-between gap-6 mb-8">
                <div className="flex flex-col w-1/2 h-full justify-between">
                  <div className="flex w-full">
                    <p className="font-semibold sow-details-head-p">Service Provider Name:</p>
                    <p>{sowDetails.firmName}</p>
                  </div>
                  <div className="flex w-full">
                    <p className="font-semibold sow-details-head-p">Startup Name:</p>
                    <p>{sowDetails.startupName}</p>
                  </div>
                  <div className="flex w-full">
                    <p className="font-semibold sow-details-head-p">Invoice Date:</p>
                    <p>{moment(new Date()).format('MMM Do YYYY').toString()}</p>
                  </div>
                </div>
              </div>
              <div className="w-full">
                <div className="w-full flex gap-2 py-2 border-b border-1 border-cBlack">
                  <div className="h-full items-center" style={{ width: '64%', display: 'inline-flex' }}>
                    <p className="font-semibold">Total SoW Quote</p>
                  </div>
                  <div className="h-full flex-col justify-center" style={{ width: '24%', display: 'inline-flex' }}>
                    <p className=""><span className="font-semibold">{`Total: `}</span> {getRetainerTotal().toFixed(2)}$</p>
                  </div>
                </div>
                <div className="w-full flex gap-2 py-2">
                  <div className="h-full items-center" style={{ width: '64%', display: 'inline-flex' }}>
                    <p className="font-semibold">50% Retainer</p>
                  </div>
                  <div className="h-full flex-col justify-center" style={{ width: '24%', display: 'inline-flex' }}>
                    <p className=""><span className="font-semibold">{`Total: `}</span> {getRetainerTotal() / 2}$</p>
                  </div>
                </div>
              </div>
              {
              sowDetails.paymentDetails && 
                <div className="flex flex-col">
                  <p>Account: {sowDetails.paymentDetails.account}</p>
                  <p>Transit: {sowDetails.paymentDetails.transit}</p>
                  <p>Institution: {sowDetails.paymentDetails.institution}</p>
                </div>
              }
            </div>
            {sowDetails.paymentDetails ?
            <div className="mb-4 flex gap-4 flex-wrap ">
              <div>
                Payment details Incorrect? Please reach out to <a href="mailto:elevateip@communitech.ca">elevateip@communitech.ca</a> for assistance updating your Firms payment details
              </div>
              <Button
                buttonText={"Submit Invoice"}
                actionHandler={() => createNewRetainerInvoice()}
                buttonType="primary"
              />
              <Button
                buttonText={"Export as PDF"}
                actionHandler={() => handleInvoiceDownload()}
                buttonType="secondary"
              />
            </div>
            :
            <div>
              Payment details are missing for your Firm.  Please reach out to <a href="mailto:elevateip@communitech.ca">elevateip@communitech.ca</a> for assistance adding your Firms payment details
            </div>}
          </div>
        </div>
        }
      <div className="flex flex-col mx-[56px]">
        {isAddingFinalInvoice ?
        <h1 className="mb-8">{pageTitleString(sowDetails.sowStatus)}</h1>
        :
        <h1 className="mb-8">Please fill in all required details to comnplete invoice</h1>
        }
        {sowDetails.sowStatus === "Ready to Begin Work" && !isAddingFinalInvoice &&
          <div className="mb-4 flex gap-4 flex-wrap ">
            <Button
              buttonText={"Mark Work Complete and Create Invoice"}
              actionHandler={() => setIsAddingFinalInvoice(true)}
              buttonType="primary"
            />
            {
              !existingRetainerInvoice &&
              <Button
                buttonText={"Create Retainer Invoice"}
                actionHandler={() => setIsRetainerModalOpen(true)}
                buttonType="primary"
              />
            }
          </div>
        }
        {sowDetails.sowStatus === "Ready to Begin Work" && isAddingFinalInvoice &&
          <div className="mb-4 flex gap-4 flex-wrap ">
            <Button
              buttonText={"Submit Invoice"}
              actionHandler={() => setIsAddingFinalInvoice(false)}
              buttonType="primary"
              disabled={true}
            />
            <Button
              buttonText={"Cancel"}
              actionHandler={() => setIsAddingFinalInvoice(false)}
              buttonType="secondary"
            />
          </div>
        }
          <div className="flex justify-between gap-6 mb-8">
            {!isAddingFinalInvoice &&
            <div className="w-full flex">
              <div className="flex flex-col w-1/2">
                <h3 className="font-semibold">ElevateIP</h3>
                <h3>Tier {`${sowDetails.tier}`} Scope of Work (SoW)</h3>
                <h3>and Attestation of Fund Usage</h3>
              </div>
              <div className="flex flex-col w-1/2 h-full justify-between">
                <div className="flex w-full">
                  <p className="font-semibold sow-details-head-p">Service Provider Name:</p>
                  <p>{sowDetails.firmName}</p>
                </div>
                <div className="flex w-full">
                  <p className="font-semibold sow-details-head-p">Startup Name:</p>
                  <p>{sowDetails.startupName}</p>
                </div>
                <div className="flex w-full">
                  <p className="font-semibold sow-details-head-p">Date:</p>
                  <p>{moment(sowDetails.providerToStartUpDate).format('MMM Do YYYY').toString()}</p>
                </div>
                
              </div>
            <div className="flex justify-between gap-6 mb-8">
                <h2 className="bodyLarger font-semibold w-1/2">{sowDetails.title}</h2>
                <p className="bodyLarger w-1/2">{sowDetails.description}</p>
            </div>
          </div>
          }
                </div>
          <div className="w-full border-cSage border-t-[1px] border-b-1px">
              <div className="flex flex-col w-full mt-4">
                  <div className="w-full font-medium flex gap-2 bg-backgrounds text-text">
                  <div className="h-full " style={{ width: '15%', display: 'inline-block' }}>
                      <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Category</p>
                  </div>
                  <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                      <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Task Description</p>
                  </div>
                  <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                      <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Deliverable</p>
                  </div>
                  {/* <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                      <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Effort (hours)</p>
                  </div> */}
                  <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                      <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Date</p>
                  </div>
                  <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                      <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Cost Breakdown ($ CAD)</p>
                  </div>
                  </div>
              </div>
          </div>
        <div className="mb-8">
          {sowHtml}
        </div>
      </div>
    </div>
  )
}

export default EditSOW